<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="2.08696" rx="1.04348"/>
<rect y="5.95653" width="10.88" height="2.08696" rx="1.04348"/>
<path d="M16 10.1304L15.2 9.34783L14.4 8.56522L13.6 7.78261L12.8 7L13.6 6.21739L14.4 5.43479L15.2 4.65218L16 3.86957V5.43479V7V8.56522V9.34783V10.1304Z"/>
<rect y="11.913" width="16" height="2.08696" rx="1.04348"/>
</svg>
</template>
